/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 操作state
 * @Date: 2021-10-18 14:44:58
 * @LastEditTime: 2022-03-15 15:00:17
 */


const initalState = {
  userInfo: {},
  containerRef: '' //页面容器
}

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case 'USERINFO':
      return {
        ...state,
        userInfo: action.userInfo
      }
      case 'CONTAINER':
        return {
          ...state,
          containerRef: action.payload
        }
        default:
          return initalState
  }
}
export default reducer